import { ClockCounterClockwise, MapPin, Pen } from "@phosphor-icons/react";
import { useState } from "react";
import PopUp from "../utils/PopUp";
import { toast } from "sonner";
import axios from "axios";

const CardLogisticsCrew = ({ cb, id_user, location, coords }) => {
  const [isVisible, setIsVisible] = useState(false);
  const onClose = () => {
    setIsVisible(false);
  };
  const handleEdit = () => {
    setIsVisible(true);
    
  };

  const nameLogistics = cb.name;
  const uniqueCode = cb.unique_code;
  const category = cb.category;
  const last_user_name = cb.username;
  const location_name = cb.location_logistics_name;
  const location_coords = cb.location_logistics_cords;
  const status = cb.status;
  const last_time =
    cb.updated_at !== null && cb.updated_at !== undefined
      ? cb.updated_at
      : cb.created_at;

  return (
    <div>
      <HandleForm
        onClose={onClose}
        isVisible={isVisible}
        active={"aktif"}
        cb={cb}
        id_user={id_user}
        location={location}
        coords={coords}
      />
      {(id_user === cb.last_user_id ) || (cb.status === "Ready" || cb.status === "Broken") ? (
        <div className="flex justify-end">
          <div className="flex items-center h-6 w-24 justify-evenly  relative right-0 shadow  bg-slate-50 rounded-t-lg">
            <div
              className={`min-w-2 min-h-2 rounded-full ${
                status === "Ready"
                  ? "bg-green-700 "
                  : status === "Use"
                  ? "bg-orange-500 "
                  : status === "Maintenance"
                  ? "bg-amber-400 "
                  : status === "Broken"
                  ? "bg-red-700 "
                  : "bg-gray-300 "
              }`}
            ></div>
            <div
              onClick={handleEdit}
              className={` cursor-pointer hidden justify-center items-center ${
                status === "Ready"
                  ? "text-green-700"
                  : status === "Use"
                  ? "text-orange-500 "
                  : status === "Maintenance"
                  ? "text-amber-400 "
                  : status === "Broken"
                  ? "text-red-700 "
                  : "text-gray-300 "
              }`}
            >
              <MapPin weight="fill" size={12} />
            </div>
            <div
              onClick={handleEdit}
              className=" cursor-pointer   text-yellow-500 flex justify-center items-center"
            >
              {/* ini  */}
              <Pen weight="bold" size={15} />
            </div>
            <div className="absolute w-full bg-red- h-1 -mb-0.5 z-[1] bg-slate-50 bottom-0"></div>
          </div>
        </div>
      ) : (
        <div className="flex justify-end">
          <div
            // onClick={handleEdit}
            className="w-12 cursor-pointer text-yellow-500 h-6 relative right-0 shadow  bg-slate-50 rounded-t-lg flex justify-center items-center"
          >
            <div
              className={`min-w-2 min-h-2 rounded-full ${
                status === "Ready"
                  ? "bg-green-700 "
                  : status === "Use"
                  ? "bg-orange-500 "
                  : status === "Maintenance"
                  ? "bg-amber-400 "
                  : status === "Broken"
                  ? "bg-red-700 "
                  : "bg-gray-300 "
              }`}
            ></div>
            <div className="absolute w-full bg-red- h-1 -mb-0.5 z-[1] bg-slate-50 bottom-0"></div>
          </div>
        </div>
      )}

      <div className="p-2 relative rounded-lg rounded-se-none shadow flex flex-col gap-2 bg-slate-50">
        <div className="flex border-b border-gray-400 justify-between">
          <p className="text-md  font-semibold">{nameLogistics}</p>
          <p className="text-md  font-semibold">{uniqueCode}</p>
        </div>
        <div className="flex gap-2">
          <div
            className={`
          ${
            status === "Ready"
              ? "bg-green-700 text-white"
              : status === "Use"
              ? "bg-orange-500 text-white"
              : status === "Maintenance"
              ? "bg-amber-400 text-white"
              : status === "Broken"
              ? "bg-red-700 text-white"
              : "bg-gray-300 text-gray-500"
          }
          my-1.5 flex flex-col rounded-lg gap-3`}
          >
            <div className="text-sm text-slate-100 rounded-t-lg w-full px-3 font-bold text-center pt-2.5">
              {category}
            </div>
            <p
              className={
                "text-2xl h-full justify-center items-center flex flex-col font-bold "
              }
            >
              {cb.id}
            </p>
          </div>
          {/* BUILD TIME STATUS */}
          <div className="pt-1.5 px-1 flex justify-between gap-2 flex-col w-full">
            <div className="grid grid-cols-2">
              <div className="flex justify-center mb-2">
                <p className="font-semibold whitespace-nowrap text-xs">
                  Last Time
                </p>
              </div>
              <div className="flex justify-center">
                <p className="font-semibold whitespace-nowrap text-xs">
                  Location
                </p>
              </div>
              <p>{getIndochinaTime(last_time)}</p>
              <p className="text-end">{location_name}</p>
              <p>{getIndochinaDate(last_time)}</p>
              <p className="text-end text-xs flex items-center justify-end">
                {location_coords}
              </p>
            </div>
            <div className="flex gap-1.5 justify-center px-2 items-center">
              <ClockCounterClockwise />
              <p className="font-semibold whitespace-nowrap text-xs">
                {last_user_name}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardLogisticsCrew;

const HandleForm = ({
  active,
  isVisible,
  onClose,
  cb,
  id_user,
  location,
  coords,
}) => {
  const ccc =
    cb.status === "Broken" ? 1 :
    id_user === cb.last_user_id && cb.status !== "Ready"
      ? 3
      : cb.status === "Broken"
      ? 1
      : cb.status === "Maintenance"
      ? 2
      : 0;
  const [report, setReport] = useState("");
  const [condition, setCondition] = useState("");
  const [activeButton, setActiveButton] = useState(ccc);
  const [hPlaceHolder, setHPlaceHolder] = useState(
    cb.status === "Broken" || id_user === cb.last_user_id && cb.status !== "Ready" ?  "Report Logistic" : "Activity" 
  );
  const handleChange = (e) => {
    const { value } = e.target;
    setReport(value);
  };
  const handleChangeC = (e) => {
    const { value } = e.target;
    setCondition(value);
  };

  const hcUse = () => {
    setHPlaceHolder("Activity");
    setActiveButton(0);
  };
  const hcMaintenance = () => {
    setHPlaceHolder("Report");
    setActiveButton(1);
  };
  const hcBroken = () => {
    setHPlaceHolder("Report");
    setActiveButton(2);
  };
  const hcFinish = () => {
    setHPlaceHolder("Report");
    setActiveButton(3);
  };

  const handleSubmit = async () => {
    try {
      if (activeButton === 0) {
        const api = `${process.env.REACT_APP_SERVER}/api/logistics/use`;
        const update = await axios.post(api, {
          id_user,
          id_logistics: cb.id,
          location_logistics_name: location,
          location_logistics_cords: coords,
          report_activity: report,
        });
      } else if (activeButton === 1) {

        const api = `${process.env.REACT_APP_SERVER}/api/logistics/report`;
        const data = {
          id_logistics: cb.id,
          location_logistics_cords: coords,
          location_logistics_name: location,
          conditions: condition,
          id_user,
          report_conditions: report,
          status: "Maintenance",
        };
        const update = await axios.post(api, data);
      } else if (activeButton === 2) {

        const api = `${process.env.REACT_APP_SERVER}/api/logistics/report`;
        const data = {
          id_logistics: cb.id,
          location_logistics_cords: coords,
          location_logistics_name: location,
          conditions: condition,
          id_user,
          report_conditions: report,
          status: "Broken",
        };
        const update = await axios.post(api, data);
      } else if (activeButton === 3) {
        const dataj = {
          id: cb.id_last_history,
          id_user,
          id_logistics: cb.id,
          report_logistics: report,
          conditions_logistics: condition,
          location_logistics_name: location,
          location_logistics_cords: coords,
        };
        const api = `${process.env.REACT_APP_SERVER}/api/logistics/finish`;
        const squer = await axios.put(api, dataj);
      } else {
        toast.error("Ada yang salah dalam program ini");
      }

      toast.success("Update data is success");
      window.location.reload();
    } catch (e) {
      console.error(e);
      toast.error("Sorry, update data is not success");
    }
  };

  return (
    <PopUp
      isVisible={isVisible}
      onClose={onClose}
      title={ cb.status === "Broken" ? "Logistic" : (id_user === cb.last_user_id && cb.status !== "Ready") ? "Finish" : "Logistic"}
    >
      {/* BTN GROUP */}
      { cb.status === "Broken" ?
        (
        <div className="flex w-full justify-between mt-4">
          {/* maintenance */}
          <button
            onClick={hcMaintenance}
            className={`btn  ${
              activeButton === 1 && "text-white btn-warning"
            } btn-xs`}
          >
            Maintenance
          </button>
          {/* Solve */}
          <button
            onClick={hcFinish}
            className={`btn  ${
              activeButton === 3 && "text-white btn-success bg-green-700"
            } btn-xs`}
          >
            Solved
          </button>
        </div>
      )
       : (id_user === cb.last_user_id && cb.status !== "Ready") ? (
        <></>
      ) : (
        <div className="flex w-full justify-between mt-4">
          {/* use */}
          {cb.status !== "Broken" && (
            <button
              onClick={hcUse}
              className={`btn   ${
                activeButton === 0 && "text-white btn-warning bg-amber-500"
              } btn-xs`}
            >
              use
            </button>
          )}
          {/* maintenance */}
          <button
            onClick={hcMaintenance}
            className={`btn  ${
              activeButton === 1 && "text-white btn-warning"
            } btn-xs`}
          >
            Maintenance
          </button>
          {/* broken */}
          {cb.status !== "Broken" && (
            <button
              onClick={hcBroken}
              className={`btn  ${
                activeButton === 2 && "text-white bg-red-700   btn-error"
              } btn-xs`}
            >
              Broken
            </button>
          )}
        </div>
      )}

      { hPlaceHolder !== "Activity" ? (
        
        <div className="flex gap-1.5 ">
          <input
            type="text"
            value={report}
            onChange={handleChange}
            placeholder={hPlaceHolder}
            className="input mt-3 input-bordered w-full"
          />
          <input
            type="number"
            value={condition}
            onChange={handleChangeC}
            placeholder={"0%"}
            className="input mt-3  input-bordered w-14"
          />
        </div>
      ) : (
        <input
          type="text"
          value={report}
          onChange={handleChange}
          placeholder={hPlaceHolder}
          className="input mt-3 input-bordered w-full"
        />
      )}

      <div className="flex justify-end mt-2">
        <button
          onClick={handleSubmit}
          className="btn text-white  btn-success border-green-700 bg-green-700 btn-xs"
        >
          Submit
        </button>
      </div>
    </PopUp>
  );
};

function getIndochinaTime(prms) {
  const today = new Date(prms); // Waktu saat ini dalam UTC
  const utcOffset = today.getTimezoneOffset(); // Offset dalam menit
  const indochinaOffset = -420; // GMT+7 offset dalam menit

  // Menghitung selisih antara UTC dan Indochina
  const timeDifference = indochinaOffset - utcOffset;
  const indochinaTime = new Date(today.getTime() + timeDifference * 60 * 1000); // Mengonversi ke milidetik

  return indochinaTime.toLocaleString("id-ID", {
    timeZone: "Asia/Jakarta",
    hour: "2-digit",
    minute: "2-digit",
  }); // Format HH:mm
}
function getIndochinaDate(prms) {
  const today = new Date(prms); // Waktu saat ini dalam UTC
  const utcOffset = today.getTimezoneOffset(); // Offset dalam menit
  const indochinaOffset = -420; // GMT+7 offset dalam menit

  // Menghitung selisih antara UTC dan Indochina
  const timeDifference = indochinaOffset - utcOffset;
  const indochinaTime = new Date(today.getTime() + timeDifference * 60 * 1000); // Mengonversi ke milidetik

  return indochinaTime.toLocaleString("id-ID", {
    timeZone: "Asia/Jakarta",
    day: "numeric",
    month: "long",
    year: "numeric",
  }); // Format HH:mm
}
